// extracted by mini-css-extract-plugin
module.exports =  {"container":"da51a739f7--container--caPuj","image":"da51a739f7--image--MzU09","message":"da51a739f7--message--oVZ_W","button-wrapper":"da51a739f7--button-wrapper--pLBjp"};